import { ethers } from 'ethers'

export default function deepCopy(
  objOrArr: ethers.InterfaceAbi | Record<string, any>,
) {
  try {
    const json = JSON.stringify(objOrArr)
    return JSON.parse(json)
  } catch (error) {
    console.error(error)
    return null
  }
}
